import type { PublicRouteClassifierContribution } from '#kernel/public-site/public-route-classifier-types.ts';

export const leadPipelinePublicRoutePaths = {
  clientRelationship: '/cr/:token',
  quickUpdate: '/quick-update/:token',
  signDocument: '/sign-doc/:token',
} as const;

export default {
  id: 'lead-pipeline-nurturing',
  paths: Object.values(leadPipelinePublicRoutePaths),
} satisfies PublicRouteClassifierContribution;
